import React, { useEffect, useState } from 'react';
import { ref, get } from 'firebase/database';
import { database } from '../config/firebase';
import { Container, Paper, Typography, Box, Button } from '@mui/material';

const TestFirebaseData: React.FC = () => {
  const [data, setData] = useState<any>({});
  const [loading, setLoading] = useState(true);

  const fetchData = async () => {
    setLoading(true);
    const results: any = {};

    try {
      // Check accountGroups
      const groupsRef = ref(database, 'accountGroups');
      const groupsSnapshot = await get(groupsRef);
      results.accountGroups = groupsSnapshot.exists() ? groupsSnapshot.val() : 'No data';

      // Check phoneToGroup
      const phoneRef = ref(database, 'phoneToGroup');
      const phoneSnapshot = await get(phoneRef);
      results.phoneToGroup = phoneSnapshot.exists() ? phoneSnapshot.val() : 'No data';

      // Check accountSyncHistory
      const historyRef = ref(database, 'accountSyncHistory');
      const historySnapshot = await get(historyRef);
      results.accountSyncHistory = historySnapshot.exists() ? historySnapshot.val() : 'No data';

      // Check driversm2 sample (first 5 entries)
      const driversRef = ref(database, 'driversm2');
      const driversSnapshot = await get(driversRef);
      if (driversSnapshot.exists()) {
        const drivers = driversSnapshot.val();
        const driverEntries = Object.entries(drivers).slice(0, 5);
        results.driversm2Sample = Object.fromEntries(driverEntries);
      } else {
        results.driversm2Sample = 'No data';
      }

      setData(results);
    } catch (error: any) {
      console.error('Error fetching data:', error);
      setData({ error: error.message || 'Unknown error' });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Container maxWidth="lg" sx={{ mt: 4 }}>
      <Paper sx={{ p: 3 }}>
        <Typography variant="h5" gutterBottom>
          Firebase Data Debug
        </Typography>
        
        <Button onClick={fetchData} variant="contained" sx={{ mb: 2 }}>
          Refresh Data
        </Button>

        {loading ? (
          <Typography>Loading...</Typography>
        ) : (
          <Box>
            <Typography variant="h6">Database Contents:</Typography>
            <pre style={{ 
              backgroundColor: '#f5f5f5', 
              padding: '10px', 
              borderRadius: '4px',
              overflow: 'auto',
              maxHeight: '600px'
            }}>
              {JSON.stringify(data, null, 2)}
            </pre>
          </Box>
        )}
      </Paper>
    </Container>
  );
};

export default TestFirebaseData;